type ColorSet = {
  main: string;
  accent: string;
  highlight: string | null;
};
export const platformColorPallette: Record<string, ColorSet> = {
  instagram: { main: "#BC3493", accent: "#F5E1EF", highlight: "#DD99C8" },
  facebook: { main: "#1877F2", accent: "#DDEBFD", highlight: "#8BBAF8" },
  twitter: { main: "#1DA1F2", accent: "#DDF1FD", highlight: "#77C7F7" },
  youtube: { main: "#FF0000", accent: "#FFD9D9", highlight: "#FF9999" },
  telegram: { main: "#4E9ED4", accent: "#E5F1F9", highlight: null },
  imessage: { main: "#07BE30", accent: "#DAF5E0", highlight: null },
  notify: { main: "#3177B5", accent: "#E0EBF4", highlight: null },
  tiktok: { main: "#FF004F", accent: "#FFDEE8", highlight: "#FF7FA6" },
};
